import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=3f12d7d8&scoped=true"
import script from "./domain.vue?vue&type=script&lang=js"
export * from "./domain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f12d7d8",
  null
  
)

export default component.exports